/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentType } from './paymentType.model';
import { SpecialPaymentAmountType } from './specialPaymentAmountType.model';


export interface ContractBulkActionParams { 
    contractDocumentTemplateId?: number;
    contractParamTemplateId?: number;
    dateSignature?: string;
    endDate?: string;
    generateIndividualDocuments?: boolean;
    sentForSignature?: boolean;
    specialPaymentAmount?: number;
    specialPaymentAmountType?: SpecialPaymentAmountType;
    specialPaymentPercent?: number;
    specialPaymentType?: PaymentType;
    specialPaymentYear?: number;
    state?: string;
    /**
     * Hromadné generování dodatků: dodatek převezme stávající údaje zdrojové smlouvy místo výchozích údajů smlouvy (contractParamTemplateId se ignoruje)
     */
    useSourceContractParams?: boolean;
    /**
     * Hromadné generování dodatků: dodatek použije šablonu dokumentu zdrojové smlouvy (contractDocumentTemplateId se ignoruje)
     */
    useSourceDocumentTemplate?: boolean;
    valorizationDate?: string;
}
export namespace ContractBulkActionParams {
}


